import { Checkout } from '@df/checkout/checkout.interfaces';

export namespace V12RetailFinance {
    export enum PaymentMethod {
        VFinance = 'vfinance'
    }

    export interface IPaymentMethod extends Checkout.IPaymentMethod {
        config?: IPaymentMethodConfig;
    }

    export interface IPaymentMethodConfig {
        v12percent?: { [percent: number]: string };
        v12pack?: IPaymentMethodConfigPack[];
    }

    export interface IPaymentMethodConfigPack {
        max_finance_amount: number | null;
        min_finance_amount: number | null;
        package?: string;
    }

    export interface IDepositOption {
        value: number;
        title: string;
    }

    export interface IPackOption {
        id: string;
        months: number;
        interest: number;
        apr: number;
        title: string;
        minFinanceAmount: number;
        maxFinanceAmount: number;
    }

    export interface IInfo {
        productName: string;
        totalAmount: number;
        depositAmount: number;
        loanAmount: number;
        interestRate: number;
        monthlyPayment: number;
        terms: number;
        creditAmount: number;
        totalAmountPayable: number;
    }

    export interface IPaymentSubmissionData {
        method: PaymentMethod.VFinance;
        additional_data: {
            v12Percent: string;
            v12Pack: string;
        };
    }
}
